'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialize = initialize;
exports.finalize = finalize;
exports.register = register;
var $ = require('jquery');
var isFunction = require('lodash/isFunction');
var isArray = require('lodash/isArray');
var flatten = require('lodash/flatten');
var log = require('debug')('linksoft:initialize');

// An array of all registered initializers.
var _initializers = [];
// finalizers performs clean up before an element is removed from DOM
var _finalizers = [];

/**
 * Triggers initialize event for given element.
 * @param {jQuery} selector - jQuery element selector. When missing document is used as target.
 * @param args
 * @returns {void}
 */
function initialize(selector) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    var target = selector || document;
    var $e = $(target);
    log('triggering %i initializers on %o', _initializers.length, target);
    _initializers.forEach(function (i) {
        i.apply($e, args);
    });
}

function finalize(selector) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
    }

    var target = selector || document;
    var $e = $(target);
    log('triggering %i finalizers on %o', _finalizers.length, target);
    _finalizers.forEach(function (i) {
        i.apply($e, args);
    });
}

/**
 * Registers a function as initializer function to be called when initialize event occurs.
 * @param {function} initializer
 * @param isFinalizer If true, function is registered as finalizer
 * @returns {void}
 */
function register(initializer) {
    var isFinalizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var store = isFinalizer ? _finalizers : _initializers;
    if (isArray(initializer)) {
        flatten(initializer).forEach(function (i) {
            store.push(i);
        });
    } else if (isFunction(initializer)) {
        store.push(initializer);
    }
}

// aliases
var registerAll = exports.registerAll = register;
var trigger = exports.trigger = initialize;

exports.default = {
    register: register,
    initialize: initialize,
    finalize: finalize,

    // obsolete
    registerAll: registerAll,
    trigger: trigger
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/core/initialize.js
// module id = 161
// module chunks = 0